const styles = {
  root: {
    position: 'relative',
    borderRadius: '50%',
    display: 'flex',
    flexDirection: 'row',
    width: 40,
    height: 40,
  },
  avatars: {
    display: 'flex',
    '& > picture, & > div': {
      marginLeft: -10,
      zIndex: 0,
      '&:first-child': {
        marginLeft: 0,
      },
    },
  },
  emptySpot: {
    display: 'flex',
    flexDirection: 'row',
    width: 40,
    height: 40,

    backgroundColor: 'white',
    border: '1.5px dashed #C6C9CF',
    marginLeft: -10,
    borderRadius: '50%',
    backgroundBlendMode: 'normal',
    boxSizing: 'border-box',
    zIndex: 0,
  },
};

export default styles;
